import React from 'react';
import styles from './onboarding.module.css';

export default function YourWhy({ whyReason, setWhyReason }) {

    const handleInput = (e) => {
        setWhyReason(e.target.value);
    }

    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '2.5rem' }}>
                <h1 className={styles.onboardingGreeting}>
                    Remember by reconnecting with <span style={{ fontWeight: "650" }}>your why</span>
                </h1>
                <div className={styles.flexDiv}>
                    <textarea className={styles.textInput} style={{ textAlign: "justify", minHeight: "9rem", borderRadius: "1.5rem", maxWidth: "unset" }}
                        placeholder="What do you hope to get clear on in the next 2 weeks?"
                        value={whyReason}
                        onChange={handleInput}
                    />
                </div>
            </div>
        </>
    );
}
